import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { MedalComplete } from "./MedalComplete";
import { MedalDeactive } from "./MedalDeactive";
// import { ReactComponent as MedalComplete } from "../../../assets/images/Medal.svg";

const AMedalStatus = ({ medal, visible = true }) => {
  const [medalStatus, setMedalStatus] = useState(null);

  //? Renderiza a medalha
  useEffect(() => {
    if (medal && medal.medal_complete) {
      setMedalStatus(<MedalComplete style={{ width: "100%", height: "100%", display: "block" }} />);
    } else if (medal && !medal.medal_complete) {
      setMedalStatus(<MedalDeactive style={{ width: "100%", height: "100%", display: "block" }} />);
    } else {
      setMedalStatus(null);
    }
  }, [medal]);

  //? Função que traz a quantidade de nível do jogo
  const checkCondition = () => {
    // Só entra se medal existir E tiver a propriedade conditions
    if (medal && medal.conditions) {
      // maxSize = número total de condições da medalha
      const maxSize = medal.conditions.length;

      // step = array contendo apenas as condições que já estão completas
      const step = medal.conditions.filter(
        (condition) => condition.is_complete
      );

      // Retorna no formato "quantas condições completas / total de condições"
      return `${step.length}/${maxSize}`;
    }
    // Caso medal ou medal.conditions não existam,
    // a função não retorna nada (undefined)
  };

  if (!medal) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "5px",
      }}
    >
      <IconButton
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: "5px",
          cursor: "pointer",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 30,
            height: 30,
          }}
        >
          {medalStatus}
        </Box>
      </IconButton>

      <Typography
        data-testid="modalInfoActivities_medalStatusText"
        sx={{
          color: "#595959",
          fontWeight: "700",
          fontSize: "11px",
          textAlign: "center",
          display: visible ? "visible" : "none"
        }}
      >
        {checkCondition()}
      </Typography>
    </Box>

  );
};

export default AMedalStatus;
